module.exports = __webpack_public_path__ + "assets/img/mtTitle-e5809368.png";